import { ArrowUpRight } from "lucide-react";
import { FadeIn, SectionHeader } from "../components/Motion";
import { scrollToId } from "../lib/scroll";

const SERVICES = [
  {
    n: "01",
    title: "Shelf-Life Estimation Report",
    body: "A science-backed predicted shelf life for your product, with the full documented rationale — ready for retailer conversations and audit files.",
  },
  {
    n: "02",
    title: "Date-Marking Rationale",
    body: "Use-by and best-before rationale, informed by FSANZ Standard 1.2.5, so the date on your pack has a documented basis.",
  },
  {
    n: "03",
    title: "Formulation & Packaging Review",
    body: "How water activity, pH, ingredients, packaging, and storage conditions move your shelf life — and the levers that extend it.",
  },
];

const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-28 sm:py-36">
    <div className="pointer-events-none absolute right-0 top-1/4 h-[400px] w-[400px] rounded-full bg-green-500/8 blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="04"
        label="Services"
        title="Everything between the recipe and the lab."
      />
      <div className="mt-20 divide-y divide-white/10 border-y border-white/10">
        {SERVICES.map((s, i) => (
          <FadeIn key={s.n} delay={i * 0.06}>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollToId("contact"); }}
              data-testid={`service-row-${s.n}`}
              className="group grid grid-cols-[auto_1fr_auto] items-center gap-6 py-8 transition-colors duration-500 hover:bg-white/[0.03] sm:gap-10 sm:py-10"
            >
              <span className="font-mono text-sm tracking-[0.3em] text-purple-400 transition-colors duration-500 group-hover:text-green-300">
                {s.n}
              </span>
              <div>
                <h3 className="font-display text-xl font-semibold text-slate-50 transition-colors duration-500 group-hover:text-green-200 sm:text-2xl">
                  {s.title}
                </h3>
                <p className="mt-2 max-w-2xl text-base leading-relaxed text-slate-400">{s.body}</p>
              </div>
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-slate-400 transition-all duration-500 group-hover:border-green-400/60 group-hover:bg-green-400/10 group-hover:text-green-300">
                <ArrowUpRight className="h-5 w-5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </a>
          </FadeIn>
        ))}
      </div>
      <FadeIn delay={0.2}>
        <p className="mt-6 max-w-3xl text-sm leading-relaxed text-slate-500" data-testid="services-disclaimer">
          Shelf Sense reports are decision-support estimates based on published research and predictive models. They are not a substitute for laboratory shelf-life testing.
        </p>
      </FadeIn>
    </div>
  </section>
);

export default Services;
